import React, { useCallback, useEffect, useState } from "react";
import {
  useGetAllDocumentsList,
  useGetAllDocumentsListAllPagesForServicesFilter,
  useGetDocumentDetails,
  useGetprovidersListForFilters,
  UseGetRfiListForFilters,
} from "../custom-hooks/queries";
import { useRfiServiceFilterOptions } from "../custom-hooks/useCatalogFilterOptions";
import CustomCards from "../components/CustomCards";
import Drawer from "../components/Drawer";
import FIltersDropdown from "../components/Filters/FiltersDropdown";
import Pagination from "../components/CustomPagination";
import CustomCardsSkeleton from "../components/CustomCardsSkeleton";
import MainSearchBar from "../components/MainSearchbar";
import { useScreenWidth } from "../custom-hooks/useScreenWidth";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import { setSearchTextByPage } from "../redux-store/features/providerFiltersSlice";
import Notification from "../components/Notification";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useLocation } from "react-router-dom";
import { setDrawer } from "../redux-store/features/layoutSlice";
import { getLocationFromProvider } from "../utils/addressUtils";

const VQA_LIBRARY_DOCUMENT_TYPES = ["VQA"];

export const VqaLibrary = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [docId, setDocId] = useState("");
  const dispatch = useDispatch();
  //   const searchQuery = useSelector((state) => state.providersFilters.searchText);
  //   const searchQueryDocsLibrary = useSelector(
  //     (state) => state.providersFilters.searchTextDocs
  //   );
  const [show, setShow] = useState(false);
  const screenWidth = useScreenWidth();
  const location = useLocation();
  const { data: providers } = useGetprovidersListForFilters();

  const { data: rfis } = UseGetRfiListForFilters();
  const {
    data: allVqaDocumentsForServices,
    isFetched: vqaLibraryAllPagesFetched,
  } = useGetAllDocumentsListAllPagesForServicesFilter(VQA_LIBRARY_DOCUMENT_TYPES);

  const servicesFilterOptions = useRfiServiceFilterOptions(
    rfis,
    allVqaDocumentsForServices?.items,
    vqaLibraryAllPagesFetched
  );

  const searchQuery =
    useSelector(
      (state) => state.providersFilters.searchTextByPage["vqaLibrary"]
    ) || "";
  const filters = [
    {
      id: "provider",
      name: "Vendor",
      options: providers,
      total: 1335,
    },
    {
      id: "status",
      name: "Status",
      options: [
        { statusID: "Released", label: "Released", checked: false },
        { statusID: "Pending", label: "Pending", checked: false },
        { statusID: "Published", label: "Published", checked: false },
        { statusID: "Cancelled", label: "Cancelled", checked: false },
        { statusID: "Upcoming", label: "Upcoming", checked: false },
      ],
      total: 5,
    },
    {
      id: "services",
      name: "Services",
      options: servicesFilterOptions,
      total: servicesFilterOptions?.length ?? 0,
    },
  ];

  useEffect(() => {
    if (isError) {
      setShow(true);
    } else {
      setShow(false);
    }
  });
  const debouncedOnSubmit = useCallback(
    debounce((search) => {
      dispatch(
        setSearchTextByPage({
          pageKey: "vqaLibrary",
          searchText: searchQuery,
        })
      );
    }, 300),
    [dispatch]
  );

  const onSubmit = (search) => {
    debouncedOnSubmit(search);
  };

  const [selectedIds, setSelectedIds] = useState({
    docType: [],
    provider: [],
    status: [],
    services: [],
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedIds, searchQuery]);

  // For Documents/Audit page, pass service names instead of IDs
  const serviceNames =
    selectedIds.services?.map((serviceId) => {
      // Find the service name from the RFI data
      const service = rfis?.find(
        (rfi) =>
          rfi.rfi_id === serviceId ||
          rfi.id === serviceId ||
          rfi.hash_id === serviceId
      );
      return (
        service?.services || service?.rfi_name || service?.name || serviceId
      );
    }) || [];
  const rfiIds = [];

  const {
    data,
    isLoading,
    isError,
    error,
    refetch: libraryRefetech,
  } = useGetAllDocumentsList(
    currentPage,
    searchQuery,
    ["VQA"],
    selectedIds.provider,
    selectedIds.status,
    rfiIds, // Empty array for Documents/Audit page
    undefined, // vqaId
    undefined, // entityId
    serviceNames // Pass service names
  );

  const {
    data: drawerData,
    isPending: drawerLoading,
    isSuccess: drawerIsSuccess,
    refetch,
  } = useGetDocumentDetails(docId);

  const isDrawerOpen = useSelector((state) => state.layout.drawerOpen);

  // const openDrawer = (documentId) => {
  //   mutate(documentId);
  //   dispatch(setDrawer(true));
  // };

  const getDocLocation = (item, short = true) => {
    return getLocationFromProvider({
      address: item?.document_address || item?.document_location,
      city: item?.document_city,
      state: item?.document_state,
      country: item?.document_country
    }, { short, abbvState: true });
  };

  return (
    <div className="container px-4">
      <div className="mt-6 pb-5 space-y-3 border-b border-gray-200 px-5 ">
        <h1 className="font-semibold">Document Library | Audit</h1>
        <p className="text-sm">
          The below displays a comprehensive list of all Vendor Qualification
          Assessment (VQA).
        </p>
      </div>
      <div className="items-center mt-5 px-5">
        <div className="flex justify-between items-center">
          <MainSearchBar
            pageKey="vqaLibrary"
            placeholder="Search documents..."
            height="40px"
            width={
              screenWidth <= 375
                ? "17.5rem"
                : screenWidth < 425
                ? "22rem"
                : "25rem"
            }
            marginRight={"mr-2"}
            isSearchIcon={true}
            onSearch={onSubmit}
          />
          <FIltersDropdown
            rfis={rfis}
            providers={providers}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
            filters={filters}
          />
        </div>
      </div>
      {isLoading ? (
        <CustomCardsSkeleton isProviderDetail={true} />
      ) : (
        <>
          {data?.items.length === 0 ? (
            <div
              className="flex flex-col items-center  justify-center text-center space-y-2 min-h-96"
              style={{
                marginTop: "100px",
              }}
            >
              <span className="p-3 rounded-full bg-custom-link-bg-color">
                <MagnifyingGlassIcon
                  width={20}
                  height={20}
                  style={{ color: "white" }}
                />
              </span>
              <p className="text-lg text-gray-700 font-semibold">
                {"No documents found"}
              </p>
              <p className="text-gray-500">
                {"Your search did not match any documents. Please try again."}
              </p>
            </div>
          ) : (
            <div className="flex flex-wrap justify-center lg:justify-start 2xl:justify-start items-start mt-5 min-h-96">
              {data?.items.map((item, index) => (
                <div
                  key={index}
                  className={`mb-4 md:${
                    index % 2 === 0 ? "ml-0" : "ml-10"
                  } md:ml-4`}
                >
                  <CustomCards
                    documentType={item?.entity_type}
                    name={item?.provider_name}
                    status={item?.document_status}
                    services={item.capabilities}
                    entityId={item?.entity_id}
                    publishedDate={item.published_on}
                    requestedDate={item?.requested_on}
                    docLocation={getDocLocation(item)}
                    docLocationFull={getDocLocation(item, false)}
                    docId={item?.document_id}
                    onClick={() => {
                      setDocId(item?.document_id);
                      dispatch(setDrawer(true));
                    }} // Pass item to openDrawer
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {isDrawerOpen && (
        <Drawer
          open={isDrawerOpen}
          // onClose={closeDrawer} // Close the drawer
          docId={drawerData?.document_id}
          docType={drawerData?.document_type}
          docName={drawerData?.document_name}
          documents={drawerData}
          drawerLoading={drawerLoading}
          drawerIsSuccess={drawerIsSuccess}
          refetch={refetch}
          libraryRefetech={libraryRefetech}
        />
      )}
      {!isLoading && data?.items.length > 0 && !isError && (
        <Pagination
          totalPages={data?.total_pages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}

      <Notification
        show={show}
        setShow={setShow}
        errorMessage={error?.message}
        status={"error"}
      />
    </div>
  );
};
